import {ColumnStore} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {
  columnAvatarConfig,
  getCustomGroupRenderer, getOriginalRecord,
} from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";


export default class ReminderRecipientsColumn extends SwivuSortColumn {
  static get $name() {
    return "ReminderRecipientsColumn";
  }

  static get type() {
    return WIDGET_KEYS.reminderRecipientsColumn;
  }

  static get defaults() {
    return {
      text: "Notify Recipients",
      field: "reminderRecipientValues",
      maxWidth: "40em",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      renderer({ record, size }) {
        const originalRecord = getOriginalRecord(record);
        const dataset = (v) => ({
          id: v.id,
        })
        // Todo: the filter chain should be removed once the issue of orphan recipient user record is fixed from the backend
        const userRecords = (originalRecord.alertRecipients || []).filter((recipient) => recipient.userRecord);
        const hasUsers = userRecords.length;

        return (hasUsers ? userRecords : [{userRecord: {name: 'N/A', id: ""}}]).map(({ userRecord }) => (
          columnAvatarConfig.columnAvatarRenderer({
            image: userRecord.profileImageURL,
            name: userRecord.name,
            size: size.configuredHeight,
            showName: !hasUsers,
            showAvatar: hasUsers,
            containerConfig: {
              id: "swivu-recipient-editor-button",
              dataset: dataset(userRecord)
            }
          })));
      },
      groupRenderer(event) {
        return getCustomGroupRenderer(event);
      },
      filterType: "_swivu_settings",
      editor: false,
      tooltipRenderer: columnAvatarConfig.tooltipRenderer
    }
  }
}

ColumnStore.registerColumnType(ReminderRecipientsColumn);
